import { HeroBackground, ProductMain } from '@prishapolicy/shared/ui';
import {
  CoverageExclusions,
  CyberInsuranceFaqList,
  Faq,
  FirstTabData,
  HeroTicker,
  ProductCategoryPageProps,
  SecondTabData,
  WhyChooseUs,
  getPurchaseFlowHeroForms,
  productsPathAdder,
  useW3PurchaseFlow,
} from '@prishapolicy/w3/ui';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import React from 'react';
const productCategorySlug = 'cyber-insurance';
import cyberLock from './cyberLock.png';
import illustrationImage1 from './illustrationLeft.png';
import illustrationImage2 from './illustrationRight.png';
import ArrowRightLineIcon from 'remixicon-react/ArrowRightSLineIcon';
import Link from 'next/link';

export const CyberInsurance = (props: ProductCategoryPageProps) => {
  const { FormRenderer } = useW3PurchaseFlow(props);
  return (
    <div>
      <NextSeo
        title="Commercial Cyber Risk Insurance | PrishaPolicy"
        description="  Because safeguarding your digital assets in todays technology-driven world is crucial."
      />
      <ProductMain color="yellow">
        <HeroBackground backgroundColor="yellow-400" PurchaseFlowFormRenderer={FormRenderer}>
          <div className="grid-cols-2 lg:grid ">
            <div className="flex flex-col justify-between">
              <div className="mb-3">
                <h1 className="heading-1 pb-3">
                  Commercial Cyber
                  <br />
                  Risk Insurance
                </h1>
                <p className="text-title-6  max-w-[600px]">
                  Because safeguarding your digital assets in todays technology-driven world is crucial.
                </p>
              </div>
            </div>
            <div className="hidden w-full items-end justify-center lg:flex">
              <div className="lg:w-3/4">
                <Image src={cyberLock} alt="cyber insurance" />
              </div>
            </div>
          </div>
        </HeroBackground>
        <HeroTicker />
        <div className=" flex flex-col ">
          <div className="container flex flex-col gap-4">
            <h1 className="text-body-1 flex font-medium">
              <Link href="/products/liability-insurance">Liability Insurance</Link>
              <span className="px-2">
                <ArrowRightLineIcon />
              </span>
              Cyber Risk Insurance
            </h1>
            <div className="flex flex-col gap-11">
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div className="flex flex-col justify-center gap-4">
                  <h1 className="text-title-4 lg:text-title-3  font-bold">What are Cyber Risks?</h1>
                  <p className="text-title-7  prose font-normal">
                    Cyber risk refers to the potential for harm or damage to an individual, organization, or society as
                    a whole resulting from a breach of computer security or other forms of cyber threats. Cyber risks
                    include threats to computer systems, networks, and electronic devices, as well as the data and
                    information that is stored, processed, or transmitted through these systems.
                  </p>
                </div>
                <div>
                  <Image src={illustrationImage1} alt="cyber insurance" width={520} height={358} />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
                <div className="order-2 lg:order-1">
                  <Image src={illustrationImage2} alt="cyber insurance" width={520} height={358} />
                </div>
                <div className="order-1 flex flex-col justify-center gap-4 lg:order-2">
                  <h1 className="text-title-4 lg:text-title-3  font-bold">
                    Why Cyber Risk Insurance becomes important?
                  </h1>
                  <p className="text-title-7  prose font-normal">
                    Cyber insurance has become increasingly important in todays digital age as more and more businesses
                    and individuals rely on technology to store, process, and transmit sensitive information. Cyber
                    insurance provides protection against losses that may arise from a cyber attack or data breach
                  </p>
                </div>
              </div>
            </div>
          </div>

          <CoverageExclusions
            title={'Coverages and Exclusions'}
            description={' Check out what’s covered and what’s not. It’s like your guidelines before buying'}
            firstTabValue={'Covered'}
            firstTabData={FirstTabData}
            secondTabValue={'Excluded'}
            secondTabData={SecondTabData}
          />

          <WhyChooseUs />
          <div className="container">
            <Faq list={CyberInsuranceFaqList} />
          </div>
        </div>
      </ProductMain>
    </div>
  );
};

export function getStaticProps() {
  const productPaths = productsPathAdder(productCategorySlug);
  return {
    props: {
      ...getPurchaseFlowHeroForms(productCategorySlug).props,
      productPaths,
    },
  };
}
export default CyberInsurance;
